import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpService } from './http.service';
import { LegacyBookInitService } from './legacy-book-initializer.service';
import { PayTokenResponse } from 'app/model/shared/backend-api-response/pay-token-response';

@Injectable()
export class CardProcessingService {
  iFrameTokenUrl: any;
  iFrameTokenProp: any;
  errorMessage: string = '';
  constructor(private _http: HttpClient, public httpService: HttpService, private ConfigService: LegacyBookInitService) {}
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  getIframeToken(tenantId): Observable<any[] | ArrayBuffer | PayTokenResponse> {
    this.iFrameTokenUrl = this.ConfigService.getCardProcessing();
    this.iFrameTokenProp = this.ConfigService.PropertyData.PropNameKeyList.token;
    let url;

    url =
      this.ConfigService.getCloudDomainName() +
      '/' +
      this.iFrameTokenUrl +
      '/tenants/' +
      tenantId +
      ('/context/' + this.ConfigService.PropertyData.ContextId + '/') +
      'propertyName/' +
      this.iFrameTokenProp +
      '/appId/RESNET_RGP?appName=wbe';
    return this.httpService.get(url, this.ConfigService.serviceHeaders).pipe(
      tap((cardProcessingData) => {
        console.log(cardProcessingData);
      }),
      catchError(this.handleError('getOffers', []))
    );
  }
  private errorHandle = (error) => {
    console.log(error);
    this.errorMessage = error.ErrorMessage;
  };

  async checkForPaymentStyle(url) {
    const t = new Date().getTime();
    url = url + `?t=${t}&${this.ConfigService.azureBlobTokenKey}`;
    await this._http.get(url, { responseType: 'blob' }).toPromise();
  }

  async checkForMultiLangCss(iframe) {
    let paymentStyleUrl = iframe.paymentStylesUrl;
    if (this.ConfigService?.PropertyData?.propertySettings?.functionalPermissions?.multiLanguageSupport && paymentStyleUrl) {
      let res = paymentStyleUrl.split('/');
      let filename = res.pop();
      let selectedLangCode =
        sessionStorage.getItem(`${this.ConfigService.tenantId}-${this.ConfigService.propertyId}-selectedLanguage`) || 'EN';
      let newFileName = filename.split('.')[0] + '-' + selectedLangCode + '.' + filename.split('.')[1];
      paymentStyleUrl = paymentStyleUrl.replace(filename, newFileName);
      await this.checkForPaymentStyle(paymentStyleUrl)
        .then((data) => {
          console.log(data);
        })
        .catch((e) => {
          console.log(e);
          if (e.status === 404) {
            paymentStyleUrl = iframe.paymentStylesUrl;
          }
        });
    }
    console.log(paymentStyleUrl);
    return paymentStyleUrl;
  }
}
